/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfInternalCommonCustomAttributeBooleanType, InternalCommonCustomAttributeBooleanTypeFromJSONTyped, InternalCommonCustomAttributeBooleanTypeToJSON, } from './InternalCommonCustomAttributeBooleanType';
import { instanceOfInternalCommonCustomAttributeDateType, InternalCommonCustomAttributeDateTypeFromJSONTyped, InternalCommonCustomAttributeDateTypeToJSON, } from './InternalCommonCustomAttributeDateType';
import { instanceOfInternalCommonCustomAttributeDecimalType, InternalCommonCustomAttributeDecimalTypeFromJSONTyped, InternalCommonCustomAttributeDecimalTypeToJSON, } from './InternalCommonCustomAttributeDecimalType';
import { instanceOfInternalCommonCustomAttributeDoubleSelectType, InternalCommonCustomAttributeDoubleSelectTypeFromJSONTyped, InternalCommonCustomAttributeDoubleSelectTypeToJSON, } from './InternalCommonCustomAttributeDoubleSelectType';
import { instanceOfInternalCommonCustomAttributeSelectType, InternalCommonCustomAttributeSelectTypeFromJSONTyped, InternalCommonCustomAttributeSelectTypeToJSON, } from './InternalCommonCustomAttributeSelectType';
import { instanceOfInternalCommonCustomAttributeTextType, InternalCommonCustomAttributeTextTypeFromJSONTyped, InternalCommonCustomAttributeTextTypeToJSON, } from './InternalCommonCustomAttributeTextType';
export function InternalCommonCustomAttributeFromJSON(json) {
    return InternalCommonCustomAttributeFromJSONTyped(json, false);
}
export function InternalCommonCustomAttributeFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfInternalCommonCustomAttributeBooleanType(json)) {
        return InternalCommonCustomAttributeBooleanTypeFromJSONTyped(json, true);
    }
    if (instanceOfInternalCommonCustomAttributeDateType(json)) {
        return InternalCommonCustomAttributeDateTypeFromJSONTyped(json, true);
    }
    if (instanceOfInternalCommonCustomAttributeDecimalType(json)) {
        return InternalCommonCustomAttributeDecimalTypeFromJSONTyped(json, true);
    }
    if (instanceOfInternalCommonCustomAttributeDoubleSelectType(json)) {
        return InternalCommonCustomAttributeDoubleSelectTypeFromJSONTyped(json, true);
    }
    if (instanceOfInternalCommonCustomAttributeSelectType(json)) {
        return InternalCommonCustomAttributeSelectTypeFromJSONTyped(json, true);
    }
    if (instanceOfInternalCommonCustomAttributeTextType(json)) {
        return InternalCommonCustomAttributeTextTypeFromJSONTyped(json, true);
    }
    return {};
}
export function InternalCommonCustomAttributeToJSON(json) {
    return InternalCommonCustomAttributeToJSONTyped(json, false);
}
export function InternalCommonCustomAttributeToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfInternalCommonCustomAttributeBooleanType(value)) {
        return InternalCommonCustomAttributeBooleanTypeToJSON(value);
    }
    if (instanceOfInternalCommonCustomAttributeDateType(value)) {
        return InternalCommonCustomAttributeDateTypeToJSON(value);
    }
    if (instanceOfInternalCommonCustomAttributeDecimalType(value)) {
        return InternalCommonCustomAttributeDecimalTypeToJSON(value);
    }
    if (instanceOfInternalCommonCustomAttributeDoubleSelectType(value)) {
        return InternalCommonCustomAttributeDoubleSelectTypeToJSON(value);
    }
    if (instanceOfInternalCommonCustomAttributeSelectType(value)) {
        return InternalCommonCustomAttributeSelectTypeToJSON(value);
    }
    if (instanceOfInternalCommonCustomAttributeTextType(value)) {
        return InternalCommonCustomAttributeTextTypeToJSON(value);
    }
    return {};
}
